import { Link } from "react-router-dom";
import { ChevronRight, MapPin, Clock, Phone, Mail, Navigation } from "lucide-react";
import { useEffect } from "react";

const ateliers = [
  {
    name: "Atelier du Mac — Paris 11e",
    address: "9 Rue de Mont-Louis, 75011 Paris",
    hours: "Lun–Sam : 11h–20h (non-stop)",
    phone: "06 11 36 70 02",
    email: "contact@atelierdumac.fr",
    metro: "Philippe Auguste (ligne 2) / Père Lachaise (lignes 2 & 3)",
    mapsEmbed: "https://maps.google.com/maps?q=9+Rue+de+Mont-Louis,+75011+Paris&output=embed",
  },
];

export default function MagasinsPage() {
  useEffect(() => { document.title = "Nos Ateliers — Atelier du Mac Paris 11e"; }, []);
  return (
    <div className="bg-[#0A0A0C] min-h-screen">
      <section className="pt-32 pb-8 max-w-5xl mx-auto px-6">
        <Link to="/" className="inline-flex items-center gap-1.5 text-xs text-white/40 hover:text-white/60 mb-8 transition-colors">
          <ChevronRight className="w-3 h-3 rotate-180" />
          Retour à l'accueil
        </Link>
        <p className="text-xs font-bold uppercase tracking-widest text-[#FF5C00] mb-3">Où nous trouver</p>
        <h1 className="text-5xl sm:text-6xl font-black tracking-tighter text-white mb-4">
          Nos ateliers
        </h1>
        <p className="text-lg text-white/60 max-w-xl">
          Venez sans rendez-vous. Nos techniciens vous accueillent du lundi au samedi de 11h à 20h.
        </p>
      </section>

      <section className="pb-24 max-w-5xl mx-auto px-6">
        <div className="grid md:grid-cols-1 gap-8">
          {ateliers.map((atelier) => (
            <div
              key={atelier.name}
              data-testid="atelier-card"
              className="p-8 rounded-2xl border border-white/5 bg-[#121215] hover:border-white/10 transition-colors"
            >
              <h2 className="text-xl font-black text-white mb-6">{atelier.name}</h2>
              <div className="grid sm:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <MapPin className="w-5 h-5 text-[#FF5C00] flex-shrink-0 mt-0.5" />
                    <span className="text-sm text-white/70">{atelier.address}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Clock className="w-5 h-5 text-[#FF5C00] flex-shrink-0" />
                    <span className="text-sm text-white/70">{atelier.hours}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Navigation className="w-5 h-5 text-[#FF5C00] flex-shrink-0" />
                    <span className="text-sm text-white/70">Métro : {atelier.metro}</span>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <Phone className="w-5 h-5 text-[#FF5C00] flex-shrink-0" />
                    <span className="text-sm text-white/70">{atelier.phone}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Mail className="w-5 h-5 text-[#FF5C00] flex-shrink-0" />
                    <a href={`mailto:${atelier.email}`} className="text-sm text-white/70 hover:text-white transition-colors">
                      {atelier.email}
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-6 rounded-xl overflow-hidden border border-white/5" style={{ height: 280 }}>
                <iframe
                  title="Atelier du Mac - Google Maps"
                  src={atelier.mapsEmbed}
                  width="100%"
                  height="280"
                  style={{ border: 0, filter: "grayscale(0.3) contrast(1.1)" }}
                  allowFullScreen=""
                  loading="lazy"
                />
              </div>

              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/contact"
                  data-testid="atelier-rdv-btn"
                  className="flex items-center gap-2 bg-[#FF5C00] hover:bg-[#E05200] text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors"
                >
                  Prendre RDV
                </Link>
                <Link
                  to="/devis"
                  className="flex items-center gap-2 border border-white/20 text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:border-white/40 transition-colors"
                >
                  Devis en ligne
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Info */}
        <div className="mt-8 p-6 rounded-2xl border border-[#FF5C00]/20 bg-[#FF5C00]/5">
          <h3 className="text-sm font-bold text-white mb-2">Venue sans rendez-vous</h3>
          <p className="text-sm text-white/60 leading-relaxed">
            Vous pouvez vous présenter directement dans l'un de nos ateliers sans rendez-vous. Un technicien vous recevra pour un diagnostic gratuit et vous donnera une estimation immédiate.
          </p>
        </div>
      </section>
    </div>
  );
}
